export const getViewportPoint = (event, viewportRef) => {
  if (!viewportRef?.current) return { x: 0, y: 0 };
  const rect = viewportRef.current.getBoundingClientRect();
  return {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
  };
};

export const viewportToWorld = (point, pan, zoom) => ({
  x: (point.x - pan.x) / zoom,
  y: (point.y - pan.y) / zoom,
});

export const worldToViewport = (point, pan, zoom) => ({
  x: point.x * zoom + pan.x,
  y: point.y * zoom + pan.y,
});

export const getBoundsFromElements = (elements) => {
  if (!elements.length) {
    return { x: 0, y: 0, w: 0, h: 0 };
  }
  const xs = elements.flatMap((el) => [el.x, el.x + el.w]);
  const ys = elements.flatMap((el) => [el.y, el.y + el.h]);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);
  return {
    x: minX,
    y: minY,
    w: maxX - minX,
    h: maxY - minY,
  };
};

export const clampPointToArtboard = (point, width, height) => ({
  x: Math.min(Math.max(point.x, 0), width),
  y: Math.min(Math.max(point.y, 0), height),
});
